/* @flow */
import React from 'react';
import classnames from 'classnames/bind';

import s from './InputWithButton.styl';

const cx = classnames.bind(s);

type CircleProps = {
  className?: string,
};
const Circle = (props: CircleProps) => {
  const { className, ...childProps } = props;
  return (
    <span className={cx(className, 'Circle')} {...childProps}>
      <span className={s.inner}></span>
    </span>
  );
};

export class InputWithButton extends React.Component {
  props: {
    children?: React.Element<*>,
    loading?: boolean,
    disabled?: boolean,
    className?: string,
  };

  input: HTMLInputElement;

  static defaultProps = {
    disabled: false,
    loading: false,
  };

  /**
   * Expose focus functionality to the parent component via ref
   */
  focus = () => {
    this.input.focus();
  };

  render() {
    const { children, loading, disabled, className, ...props } = this.props;
    return (
      <div className={cx('InputWithButton', className, { disabled: loading || disabled })}>
        <input ref={el => { this.input = el; }} {...props} />
        <div className={cx('children')}>
          {loading ? <Circle className={cx('Circle')} /> : children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./web_modules/trustar/components/InputWithButton.js